// extracted by mini-css-extract-plugin
export var active = "_cn-c";
export var compactArrow = "_cn-5";
export var container = "_cn-0";
export var dot = "_cn-b";
export var dotContainer = "_cn-a";
export var hoverArrowButton = "_cn-7";
export var hoverArrowContainer = "_cn-6";
export var leftHoverArrowContainer = "_cn-8 _cn-6";
export var rightHoverArrowContainer = "_cn-9 _cn-6";
export var slide = "_cn-4";
export var sliderContainer = "_cn-1";
export var sliderContainerVisibleOverflow = "_cn-2";
export var sliderOverflow = "_cn-3";
export var vignetteBoth = "_cn-f";
export var vignetteLeft = "_cn-e";
export var vignetteRight = "_cn-d";